export const prettifyPermissionKey = (raw: string): string =>
  raw
    .split(/[_\-.]/g)
    .filter(Boolean)
    .map(
      (chunk) => chunk.charAt(0).toUpperCase() + chunk.slice(1).toLowerCase(),
    )
    .join(" ");

export const PERMISSION_SCOPE_LABELS: Record<string, string> = {
  AUDIT: "Auditoría",
  APPROVAL_FLOW: "Flujos de aprobación",
  BATCH: "Lotes",
  BATCHTEMPLATE: "Plantillas de lote",
  CARRIER: "Transportistas",
  COMPANY: "Sociedades",
  CARRIERTYPE: "Tipos de transportes",
  COSTCENTER: "Centros de costo",
  DISPATCHGUIDE: "Detalles de movimiento",
  DISPATCHGUIDESTATUS: "Estados de detalle de movimiento",
  MATERIALGROUP: "Grupos de materiales",
  MATERIALMOVEMENT: "Movimientos",
  MATERIALREQUEST: "Solicitudes de pedido",
  MATERIAL: "Materiales",
  MATERIALUNITCONVERSION: "Conversión de unidades",
  MOVEMENTTYPE: "Tipos de movimiento",
  NOTIFICATION: "Notificaciones",
  ORG_POSITION: "Puestos de trabajo",
  PERMISSION: "Permisos",
  PLANT: "Centros",
  PLANTTYPE: "Tipos de centro",
  PRODUCTIONORDER: "Órdenes de producción",
  REPORTS: "Reportes",
  ROLE: "Roles",
  ROUTE: "Rutas",
  FIELD: "Campos",
  CUARTEL: "Cuarteles",
  EMPLOYEE: "Empleados",
  ATTENDANCE: "Asistencia",
  LABOR_ACTIVITY: "Labores",
  LABOR_RATE: "Tarifas de mano de obra",
  LABOR_RATE_GENERAL: "Tarifas generales",
  SPECIES: "Especies",
  VARIETY: "Variedades",
  LABOR_TICKET: "Tarja diaria",
  STORAGEBIN: "Ubicaciones de almacén",
  STORAGELOC: "Almacenes",
  STORAGELOCLAYOUTTEMPLATE: "Ubicaciones",
  UNITS: "Unidades de medida",
  USER: "Usuarios",
  USERCOMPANY: "Personas",
  VENDOR: "Proveedores",
  CUSTOMER: "Clientes",
  COMMERCIALBUSINESSLINE: "Giros comerciales",
  PAYMENTTERM: "Condiciones de pago",
  DOCUMENTCLASS: "Clases de documento",
  VENDORSERVICE: "Servicios de proveedor",
  PURCHASEORDER: "Órdenes de compra",
  SALESORDER: "Órdenes de venta",
  WORKORDER: "Órdenes de trabajo",
  WORKORDERACTIVITY: "Maestro de actividades",
  WORKORDERTEMPLATE: "Flujos de Trabajo",
  INDUSTRIALFORMULA: "Recetas",
};

export const NAV_MODULE_TO_PERMISSION_SCOPE: Record<string, string> = {
  batches: "BATCH",
  "batch-templates": "BATCHTEMPLATE",
  carriers: "CARRIER",
  companies: "COMPANY",
  "carrier-types": "CARRIERTYPE",
  "cost-centers": "COSTCENTER",
  "dispatch-guides": "MATERIALMOVEMENT",
  "approval-flows": "APPROVAL_FLOW",
  "dispatch-guide-statuses": "DISPATCHGUIDESTATUS",
  "dispatch-flow-profiles": "DISPATCHGUIDESTATUS",
  "material-groups": "MATERIALGROUP",
  "material-movements": "MATERIALMOVEMENT",
  "material-requests": "MATERIALREQUEST",
  materials: "MATERIAL",
  "material-unit-conversions": "MATERIALUNITCONVERSION",
  "movement-types": "MOVEMENTTYPE",
  permissions: "PERMISSION",
  plants: "PLANT",
  "plant-types": "PLANTTYPE",
  "production-orders": "PRODUCTIONORDER",
  roles: "ROLE",
  routes: "ROUTE",
  fields: "FIELD",
  cuarteles: "CUARTEL",
  employees: "EMPLOYEE",
  attendance: "ATTENDANCE",
  "labor-tickets": "LABOR_TICKET",
  "labor-activities": "LABOR_ACTIVITY",
  "labor-rates": "LABOR_RATE",
  "labor-rate-generals": "LABOR_RATE_GENERAL",
  especies: "SPECIES",
  variedades: "VARIETY",
  "labor-retention": "LABOR_RETENTION",
  "storage-locations": "STORAGELOC",
  "storage-loc-templates": "STORAGELOCLAYOUTTEMPLATE",
  stock: "MATERIALMOVEMENT",
  units: "UNITS",
  users: "USER",
  vendors: "VENDOR",
  "commercial-business-lines": "COMMERCIALBUSINESSLINE",
  "vendor-services": "VENDORSERVICE",
  customers: "CUSTOMER",
  "payment-terms": "PAYMENTTERM",
  "document-classes": "DOCUMENTCLASS",
  "purchase-orders": "PURCHASEORDER",
  "sales-orders": "SALESORDER",
  "org-positions": "ORG_POSITION",
  "work-orders": "WORKORDER",
  "work-order-activities": "WORKORDERACTIVITY",
  "work-order-templates": "WORKORDERTEMPLATE",
  "industrial-formulas": "INDUSTRIALFORMULA",
  audit: "AUDIT",
};

export const NAV_MODULE_LABELS: Record<string, string> = {
  configuration: "Configuración",
  purchasing: "Compras",
  mm: "Gestión de materiales",
  logistica: "Logística",
  agricola: "Agrícola",
  fields: "Campos",
  cuarteles: "Cuarteles",
  employees: "Empleados",
  attendance: "Asistencia",
  "labor-tickets": "Tarja diaria",
  "labor-activities": "Labores",
  "labor-rates": "Tarifas Proveedores",
  "labor-retention": "Retención",
  "users-section": "Estructura organizacional",
  sales: "Ventas",
  trips: "Viajes",
  routes: "Rutas",
  "approval-flows": "Flujos de aprobación",
  "dispatch-guides": "Detalles de movimientos",
  "dispatch-guide-statuses": "Estados de detalle de movimiento",
  "dispatch-flow-profiles": "Perfiles de flujo de despacho",
  stock: "Consulta de stock",
  "material-requests": "Solicitudes de pedido",
  "sales-orders": "Pedidos de ventas",
  "work-order-activities": "Actividades",
  "industrial-formulas": "Recetas",
};

export const getPermissionScopeLabel = (scopeKey: string): string =>
  PERMISSION_SCOPE_LABELS[scopeKey] ?? prettifyPermissionKey(scopeKey);

export const getNavModuleLabel = (
  navModuleId: string,
  fallbackLabel?: string,
): string => {
  const explicitNavLabel = NAV_MODULE_LABELS[navModuleId];
  if (explicitNavLabel) {
    return explicitNavLabel;
  }

  const scopeKey = NAV_MODULE_TO_PERMISSION_SCOPE[navModuleId];
  if (scopeKey) {
    return getPermissionScopeLabel(scopeKey);
  }
  return fallbackLabel ?? prettifyPermissionKey(navModuleId);
};
